import {Component, Input} from '@angular/core';
import {NgbDateStruct} from './ngb-date-struct';


export class NgbDatepickerDayView {
   currentMonth: number;
   date: NgbDateStruct;
   disabled: boolean;
   selected: boolean;

  isMuted() { return !this.selected && (this.date.month !== this.currentMonth || this.disabled); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[ngbDatepickerDayView]',
  styles: [`
    :host {      
      text-align: center;
      padding: 0.185rem 0.25rem;      
      border-radius: 0.25rem;
    }
  `],
  host: {
    '[class.bg-primary]': 'selected',
    '[class.text-white]': 'selected',
    '[class.text-muted]': 'isMuted()',
    '[class.btn-secondary]': '!disabled'
  },
  template: `{{ date.day }}`
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'currentMonth': [{ type: Input },],
'date': [{ type: Input },],
'disabled': [{ type: Input },],
'selected': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
